import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { getLiveStream } from "../../../features/slices/liveStream";
import { useSelector } from "react-redux";
import TableSkeleton from "../../TableSkeleton";
import moment from "moment/moment";
import ExportToExcel from "../../ExportToExcel";
import CommonPagination from "../../CommonPagination";
import filterImg from "../../../assets/images/filter.png";
import { Link } from "react-router-dom";
const initialState = {
  fromDate: "",
  toDate: "",
  timeframe: "",
  searchQuery: "",
  category: "",
};
const Completed = () => {
  const [iState, setUpdateState] = useState(initialState);
  const [page, setPage] = useState(1);
  const completeRef = useRef();
  const { searchQuery, fromDate, toDate, timeframe, category } = iState;
  const disptach = useDispatch();
  const { loading, liveStreamData, categoryDropDownData } = useSelector(
    (state) => {
      return state.liveStream;
    }
  );
  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };
  const handleSubmit = () => {
    const queryParams = {
      page: 1,
      streamType: "Completed",
    };
    if (fromDate && toDate) {
      queryParams.startDate = fromDate;
      queryParams.endDate = toDate;
    } else if (timeframe) {
      queryParams.timeframe = timeframe;
    }

    disptach(getLiveStream(queryParams)).then((data) => {
      if (data?.payload?.code === 200) {
        // setUpdateState((prev) => ({
        //   ...prev,
        //   fromDate: "",
        //   toDate: "",
        //   timeframe: "",
        // }));
      }
    });
  };
  const handleTimeFrame = (e) => {
    const queryParams = {
      timeframe: e.target.value,
      streamType: "Completed",
    };
    setUpdateState((prev) => ({
      ...prev,
      timeframe: e.target.value,
    }));
    disptach(getLiveStream(queryParams)).then((data) => {
      if (data?.payload?.code === 200) {
        // setUpdateState((prev) => ({
        //   ...prev,
        //   timeframe: "",
        // }));
      }
    });
  };
  const handleReset = () => {
    setUpdateState(initialState);
    disptach(getLiveStream({ page, streamType: "Completed" }));
  };
  useEffect(() => {
    disptach(getLiveStream({ page, streamType: "Completed" }));
    window.scrollTo(0, 0);
  }, [page]);
  useEffect(() => {
    if (searchQuery.trim() !== "") {
      const delayDebounceFunc = setTimeout(() => {
        disptach(
          getLiveStream({
            search: searchQuery?.trim(),
            categoryId: category,
            streamType: "Completed",
          })
        ).then((res) => {
          if (res?.payload?.code == 200) {
            // setUpdateState((prev) => ({
            //   ...prev,
            //   searchQuery: "",
            // }));
          }
        });
      }, 1000);
      return () => clearTimeout(delayDebounceFunc);
    }
  }, [searchQuery, disptach]);
  const handleSearch = (e) => {
    const { name, value } = e.target;
    setUpdateState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeCategory = (e) => {
    setUpdateState((prev) => ({
      ...prev,
      category: e.target.value,
    }));
    disptach(
      getLiveStream({
        categoryId: e.target.value,
        search: searchQuery?.trim(),
        streamType: "Completed",
      })
    );
  };
  return (
    <div className="tab-pane fade active show" id="Completed">
      <div className="FilterArea">
        <div className="FilterLeft">
          <div className="form-group">
            <label>From Date</label>
            <input
              type="date"
              className="form-control"
              value={fromDate}
              disabled={timeframe}
              name="fromDate"
              onChange={(e) => handleSearch(e)}
            />
          </div>
          <div className="form-group">
            <label>To Date</label>
            <input
              type="date"
              className="form-control"
              name="toDate"
              value={toDate}
              disabled={timeframe}
              onChange={(e) => handleSearch(e)}
            />
          </div>
          <div className="form-group">
            <label>&nbsp;</label>
            <button className="Button" onClick={handleSubmit}>
              Apply
            </button>
          </div>
          <div className="form-group">
            <label>Timeframe</label>
            <select
              className="form-control customSelect"
              name="timeframe"
              value={timeframe}
              disabled={fromDate || toDate}
              onChange={(e) => handleTimeFrame(e)}
            >
              <option value="" hidden>
                Select
              </option>
              <option value="Today">Today</option>
              <option value="Week">This Week</option>
              <option value="Month">This Month</option>
            </select>
          </div>
        </div>
      </div>
      <div className="NewFilter">
        <div className="SearchBox">
          <input
            type="search"
            className="SearchInput"
            placeholder="Search here by ID, Name, or Others"
            name="searchQuery"
            value={searchQuery}
            onChange={(e) => handleSearch(e)}
          />
          <span>
            <i className="fa fa-search" />
          </span>
        </div>

        <div className="Actions">
          <div
            className="form-group"
            style={{
              textAlign: "center",
            }}
          >
            {/* <label
              style={{
                fontWeight: "bolder",
                fontWeight: "bolder",
                display: " block",
                whiteSpace: "nowrap",
                margin: "4px 20px",
              }}
            >
              Filter by Category
            </label> */}
            <select
              className="form-control FilterStatus"
              name="categoryId"
              onChange={handleChangeCategory}
            >
              <option value="" hidden>
                Filter by Category
              </option>
              {categoryDropDownData?.result?.map((res) => {
                return (
                  <option
                    value={res?._id}
                    selected={res?._id == category}
                    key={res?._id}
                  >
                    {res?.categoryName}
                  </option>
                );
              })}
            </select>
          </div>
          <button className="Button Cancel" onClick={handleReset}>
            <i className="fa fa-refresh" />
          </button>
          <ExportToExcel ref={completeRef} fileName="liveStreamCompletedData" />
        </div>
      </div>
      <div className="TableList">
        <table className="table-hover" ref={completeRef}>
          <thead>
            <tr>
              <th>Sr. No</th>
              <th>Livestream Id</th>
              <th>Livestream Title</th>
              <th>Category &amp; Topics</th>
              <th>Host Name</th>
              <th>Date &amp; Time</th>
              <th>No. of Attendees</th>
              <th>Avg &amp; No. of Ratings</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <TableSkeleton />
            ) : (
              liveStreamData?.result?.[0]?.paginationData?.map((res, i) => {
                return (
                  <tr key={res?._id}>
                    <td>{i + 1 + (page - 1) * 10}</td>
                    <td>{res?.stream_number}</td>
                    <td>
                      <div className="fw500">{res?.title}</div>
                    </td>
                    <td>
                      {res?.categoryData?.[0]?.categoryName} &amp;{" "}
                      {res?.topicData?.[0]?.topicName}
                    </td>
                    <td>{res?.teacherName}</td>
                    <td>
                      {moment
                        .utc(res?.liveStreamStartDate)
                        .format("YYYY/MM/DD hh:mm A")}
                    </td>
                    <td>{res?.attendCount}</td>
                    <td>
                      <Link
                        to={"review"}
                        className="LinkDirect"
                        state={res?._id}
                      >
                        <strong>{res?.averageRating}</strong> (
                        {res?.ratingCount})
                      </Link>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
      <div className="Pagination">
        {liveStreamData?.result?.[0]?.totalCount?.[0]?.count > 0 && (
          <>
            <p>
              Showing {(page - 1) * 10 + 1} to{" "}
              {Math.min(
                liveStreamData?.result?.[0]?.paginationData?.length +
                  (page - 1) * 10,
                liveStreamData?.result?.[0]?.totalCount?.[0]?.count
              )}{" "}
              of {liveStreamData?.result?.[0]?.totalCount?.[0]?.count} results
            </p>
            <div className="PaginationRight">
              <CommonPagination
                activePage={page}
                itemsCountPerPage={10}
                totalItemsCount={
                  liveStreamData?.result?.[0]?.totalCount?.[0]?.count || 0
                }
                pageRangeDisplayed={4}
                onChange={handlePageChange}
                itemClass="page-item"
                linkClass="page-link"
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Completed;
